import React from 'react'
import { css } from 'emotion'
import PageFooter from './PageFooter'
import Hero from './Hero'
import Promotions from './Promotions'
import Contact from './Contact'
import { contactbg, homebg2 } from 'images'

class HomeView extends React.Component {
  render() {
    const {
      HoursElement,
      ContactUsElement,
      OrderNowButtonElement,
      LogoElement,
      locationId,
    } = this.props
    return (
      <section className={styles.container}>
        <Hero OrderNowButtonElement={OrderNowButtonElement} />
        <Promotions locationId={locationId} />
        <div className={styles.contactbg}>
          <Contact
            HoursElement={HoursElement}
            LogoElement={LogoElement}
            ContactUsElement={ContactUsElement}
            locationId={locationId}
          />
          <PageFooter />
        </div>
      </section>
    )
  }
}

const styles = {
  container: css({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    background: `url(${homebg2}) repeat`,
    backgroundSize: 'tile',
  }),
  contactbg: css({
    maxWidth: '160rem',
    width: '100%',
    height: '100%',
    background: `url(${contactbg}) repeat`,
    backgroundSize: 'cover',
  }),
}

export default HomeView
